import { Grid } from "@mui/material";
import BlogAdd from "components/local/dashboard/blog/BlogAdd";
import SideBar from "components/UI/SideBar/SideBar";

const BlogAddPage = () => {
  return (
    <Grid container sx={{ backgroundColor: "#F5F5F5" }}>
      <Grid item md={2}>
        <SideBar />
      </Grid>
      <Grid
        item
        md={10}
        sm={6}
        xs={12}
        sx={{ marginInline: { sm: "auto", md: "initial" } }}
      >
        <BlogAdd />
      </Grid>
    </Grid>
  );
};

export default BlogAddPage;
